// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { UpdateSearchFieldsType } from "@insite/client-framework/Types/UpdateSearchFieldsType";
import { GetBlogCategoryArticlesApiParameter } from "@store/Framework/Services/BlogService";
import BlogCategoryState from "@store/Framework/Store/Starter/Pages/BlogCategory/BlogCategoryState";
import { Draft } from "immer";

const initialState: BlogCategoryState = {
    getBlogCategoryArticlesApiParameter: {
        nodeId: "",
    },
};

const actions = {
    "Starter/Pages/BlogCategory/UpdateSearchFields": (
        draft: Draft<BlogCategoryState>,
        action: { parameter: GetBlogCategoryArticlesApiParameter & UpdateSearchFieldsType },
    ) => {
        const { type } = action.parameter;
        delete action.parameter.type;
        if (type === "Replace") {
            draft.getBlogCategoryArticlesApiParameter = action.parameter;
        } else if (type === "Initialize") {
            draft.getBlogCategoryArticlesApiParameter = {
                ...initialState.getBlogCategoryArticlesApiParameter,
                ...action.parameter,
            };
        } else {
            draft.getBlogCategoryArticlesApiParameter = {
                ...draft.getBlogCategoryArticlesApiParameter,
                ...action.parameter,
            };

            for (const key in draft.getBlogCategoryArticlesApiParameter) {
                const value = (<any>draft.getBlogCategoryArticlesApiParameter)[key];

                // remove empty parameters
                if (value === "" || value === undefined) {
                    delete (<any>draft.getBlogCategoryArticlesApiParameter)[key];
                }
            }

            for (const key in action.parameter) {
                // go back to page 1 if any other parameters changed
                if (
                    draft.getBlogCategoryArticlesApiParameter.page &&
                    draft.getBlogCategoryArticlesApiParameter.page > 1 &&
                    key !== "page" &&
                    key !== "pageSize" &&
                    key !== "nodeId" &&
                    key !== "cacheInvalidationId"
                ) {
                    draft.getBlogCategoryArticlesApiParameter.page = 1;
                }
            }
        }
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BlogCategoryActions = Parameters<typeof reducer>[1];
export default reducer;
